"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodeFILE = function CategoryCodeFILE(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodeFILE"), _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M10.717,10.88v1.652H4.573V5.759L6.864,3.468l3.853,0v.765L12,5.49V3.468a1.281,1.281,0,0,0-1.281-1.281H6.864a1.281,1.281,0,0,0-.906.375L3.667,4.853a1.281,1.281,0,0,0-.375.906v6.773a1.28,1.28,0,0,0,1.281,1.281h6.144A1.281,1.281,0,0,0,12,12.532V9.659Z"
  }), _react.default.createElement("path", {
    d: "M12.684,7.544,10.438,5.3a.084.084,0,0,0-.144.059v.674a.084.084,0,0,1-.065.082A4.654,4.654,0,0,0,7.342,8.126a6.9,6.9,0,0,0-.929,2.558.084.084,0,0,0,.152.06A4.066,4.066,0,0,1,7.807,9.619a4.557,4.557,0,0,1,2.258-.546c.138,0,.219.006.219.006v.78a.085.085,0,0,0,.144.06l2.256-2.256A.084.084,0,0,0,12.684,7.544Z"
  }))));
};

var _default = CategoryCodeFILE;
exports.default = _default;